/* @ngInject */

export default (
  $q,
  $rootScope,
  helperService,
  helperPdfService,
  homeLoanService,
  quickToolService,
  dateTimeService,
  INSTANCE
) => ({
  createHomeLoanRefinanceAnalysis: ({ refinanceAnalysis, ticket, isQuickTool, isView }) => {
    const deferred = $q.defer();
    const currentOrganization = $rootScope.CurrentOrganization;
    const currentAccount = $rootScope.CurrentAccount;
    const currentCurrency = $rootScope.CurrentCurrency();
    const currentTimeZone = $rootScope.CurrentTimeZone();
    const refinanceAnalysisTable = [
      [
        [
          {
            table: {
              widths: ['*', 90],
              body: [
                [
                  {
                    colSpan: 2,
                    text: 'Refinancing loans',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: 'Refinancing loans - total outstanding balances',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinance.refinancingLoans.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Additional funds requested',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinance.additionalFundsRequested.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            layout: 'defaultLayout'
          },
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    colSpan: 2,
                    text: 'Estimated exit fees (A)',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: 'Discharge fees',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedExitFees.discharge.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Deferred establishment fees',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedExitFees.deferredEstablishment.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Break costs',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedExitFees.breakCosts.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Other associated exit costs',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedExitFees.otherAssociatedExitCosts.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            style: 'tableMarginTop',
            layout: 'defaultLayout'
          },
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    colSpan: 2,
                    text: 'Estimated entry fees (B)',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: 'Total bank fees (application, valuation, etc.)',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedEntryFees.totalBank.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'LMI - added to loan',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedEntryFees.lmi.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Mortgage registration',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedEntryFees.mortgageRegistration.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Other associated entry costs',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.estimatedEntryFees.otherAssociatedEntryCosts.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            style: 'tableMarginTop',
            layout: 'defaultLayout'
          },
          {
            table: {
              widths: ['*', '*'],
              body: [
                [
                  {
                    colSpan: 2,
                    text: 'Refinance costs',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: 'Once-off refinance cost (A+B)',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinanceCost.onceOffRefinance.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            style: 'tableMarginTop',
            layout: 'defaultLayout'
          }
        ],
        [
          {
            table: {
              widths: ['*', 90],
              body: [
                [
                  {
                    colSpan: 2,
                    text: 'Refinance funding',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  ''
                ],
                [
                  {
                    text: 'Total funds required (C)',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinanceFunding.totalFundsRequired.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Required loan amount (D)',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinanceFunding.requiredLoanAmount.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Surplus/Customer contribution (D-C)',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    text: refinanceAnalysis.refinanceFunding.surplusCustomerContribution.formatWithCurrency(
                      currentCurrency
                    ),
                    color: `${
                      refinanceAnalysis.refinanceFunding.surplusCustomerContribution >= 0
                        ? `green`
                        : `red`
                    }`,
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            layout: 'defaultLayout'
          },
          {
            table: {
              widths: ['*', 90, 90],
              body: [
                [
                  {
                    colSpan: 3,
                    text: 'Refinance benefit',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableHeader',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  '',
                  ''
                ],
                [
                  {
                    text: ''
                  },
                  {
                    text: 'Current',
                    fontSize: 9,
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  },
                  {
                    text: 'Proposed',
                    fontSize: 9,
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Interest rate',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [true, true, false, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.interestRate.current.toFixed(
                        2
                      )}%`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.interestRate.proposed.toFixed(
                        2
                      )}%`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Loan term',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [true, true, false, true],
                    text: [
                      {
                        text: refinanceAnalysis.refinanceBenefit.loanTermRemaining.current
                      },
                      {
                        text: ` ${
                          refinanceAnalysis.refinanceBenefit.loanTermRemaining.current === 1
                            ? `month`
                            : `months`
                        }`,
                        fontSize: 8
                      }
                    ],
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: [
                      {
                        text: refinanceAnalysis.refinanceBenefit.loanTermRemaining.proposed
                      },
                      {
                        text: ` ${
                          refinanceAnalysis.refinanceBenefit.loanTermRemaining.proposed === 1
                            ? `month`
                            : `months`
                        }`,
                        fontSize: 8
                      }
                    ],
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Monthly home loan repayment (P&I)',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [true, true, false, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.monthlyHomeLoanRepayment.current.formatWithCurrency(
                        currentCurrency
                      )} (E)`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.monthlyHomeLoanRepayment.proposed.formatWithCurrency(
                        currentCurrency
                      )} (F)`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    text: 'Annual ongoing fees',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [true, true, false, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.annualOngoingFees.current.formatWithCurrency(
                        currentCurrency
                      )} (G)`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: {
                      text: `${refinanceAnalysis.refinanceBenefit.annualOngoingFees.proposed.formatWithCurrency(
                        currentCurrency
                      )} (H)`
                    },
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            style: 'tableMarginTop',
            layout: 'defaultLayout'
          },
          {
            table: {
              widths: ['*', 90],
              body: [
                [
                  {
                    border: [true, true, false, true],
                    text: 'Annual benefit ((E-F)x12+(G-H))',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: refinanceAnalysis.refinanceBenefit.annualBenefit.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    border: [true, true, false, true],
                    text: 'Cashback/deposit',
                    bold: false,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: refinanceAnalysis.refinanceBenefit.cashback.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    border: [true, true, false, true],
                    text: 'Savings over the proposed loan term',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: refinanceAnalysis.refinanceBenefit.savingsOverLoanTerm.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    border: [true, true, false, true],
                    text: 'Additional monthly repayment',
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: refinanceAnalysis.refinanceBenefit.additionalMonthlyRepayment.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ],
                [
                  {
                    border: [true, true, false, true],
                    text: 'Savings over the loan term with additional monthly repayment',
                    bold: true,
                    style: [
                      'tableFontSize',
                      'tableCellLeftAlign',
                      'tableCellMarginLeftTopBottom'
                    ]
                  },
                  {
                    border: [false, true, true, true],
                    text: refinanceAnalysis.refinanceBenefit.savingsOverLoanTermWithAdditionalMonthlyRepayment.formatWithCurrency(
                      currentCurrency
                    ),
                    style: [
                      'tableFontSize',
                      'tableCellRightAlign',
                      'tableCellMarginRightTopBottom'
                    ]
                  }
                ]
              ]
            },
            margin: [0, 5, 0, 0],
            layout: 'defaultLayout'
          },
          {
            text: `With the additional monthly repayment of ${refinanceAnalysis.refinanceBenefit.additionalMonthlyRepayment.formatWithCurrency(
              currentCurrency
            )}, the proposed loan will be repaid in ${
              refinanceAnalysis.refinanceBenefit.newCalculatedLoanTerm
            } ${
              refinanceAnalysis.refinanceBenefit.newCalculatedLoanTerm === 1
                ? `month`
                : `months`
            }.`,
            fontSize: 9,
            style: 'tableMarginTop'
          }
        ]
      ]
    ];
    const now = moment.utc().tz(currentTimeZone).format('X');
    const date = dateTimeService.getFormattedDate(now);
    const orgLogo = currentOrganization?.organization?.logo
      ? currentOrganization.organization.logo.replace(
          /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/gi,
          currentOrganization.id
        )
      : INSTANCE.url + INSTANCE.logo;
    quickToolService.getBase64FromImageUrl({ url: orgLogo }).then((res) => {
      const docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        content: [
          {
            table: {
              widths: [240, '*'],
              headerRows: 1,
              body: [
                [
                  {
                    width: 180,
                    height: 30,
                    image: res.data,
                    margin: [5, 3, 0, 3],
                    style: 'tableHeader'
                  },
                  {
                    fillColor: '#eeeeee',
                    text: `Prepared by: ${currentAccount.getName()}\nPrepared on: ${date}`,
                    style: 'prepared'
                  }
                ]
              ]
            },
            layout: 'noBorders'
          },
          {
            text: 'Refinance analysis',
            style: ['header', 'marginTop']
          },
          {
            table: {
              widths: ['*', '*'],
              body: refinanceAnalysisTable
            },
            style: ['marginTop'],
            layout: 'noBorders'
          }
        ],
        styles: {
          header: {
            fontSize: 16,
            bold: true
          },
          subHeader: {
            fontSize: 12,
            bold: true,
            margin: [0, 10, 0, 4]
          },
          prepared: {
            fontSize: 10,
            alignment: 'right',
            margin: [0, 6, 5, 0]
          },
          marginTop: {
            margin: [0, 10, 0, 0]
          },
          tableFontSize: {
            fontSize: 10
          },
          tableHeader: {
            fillColor: '#eee'
          },
          tableMarginTop: {
            margin: [0, 10, 0, 0]
          },
          tableCellMarginTop: {
            margin: [0, 2, 0, 0]
          },
          tableCellMarginLeftTopBottom: {
            margin: [4, 2, 0, 2]
          },
          tableCellMarginRightTopBottom: {
            margin: [0, 2, 4, 2]
          },
          tableCellMarginTopBottom: {
            margin: [0, 2, 0, 2]
          },
          tableCellLeftAlign: {
            alignment: 'left'
          },
          tableCellRightAlign: {
            alignment: 'right'
          },
          tableCellCenterAlign: {
            alignment: 'center'
          }
        }
      };
      pdfMake.tableLayouts = {
        defaultLayout: {
          hLineWidth(i, node) {
            return i === node.table.headerRows ? 1 : 0.5;
          },
          vLineWidth(i, node) {
            return i === 1 || (i === 2 && node.table.widths.length !== 2) ? 0 : 0.5;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? '#333' : '#aaa';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? '#333' : '#aaa';
          },
          paddingLeft() {
            return 0;
          },
          paddingRight() {
            return 0;
          },
          paddingTop() {
            return 0;
          },
          paddingBottom() {
            return 0;
          }
        }
      };

      const fileName = `${moment.utc().year()}${
        moment.utc().month() + 1
      }${moment.utc().date()}${isQuickTool ? ' Quick tools -' : ''} Refinance analysis.pdf`;
      if (isQuickTool && !_.isEmpty(docDefinition)) {
        if (!_.isEmpty(docDefinition)) {
          if (isView) {
            pdfMake.createPdf(docDefinition).open();
          } else {
            pdfMake.createPdf(docDefinition).download(fileName);
          }
          deferred.resolve();
        }
      } else if (!isQuickTool && !_.isEmpty(docDefinition)) {
        if (isView) {
          helperPdfService.viewOrSavePdf({ docDefinition, isView: true }).then(() => {
            deferred.resolve();
          });
        } else {
          helperPdfService
            .viewOrSavePdf({
              ticket,
              docDefinition,
              fileName,
              isView: false
            })
            .then(() => {
              deferred.resolve();
            });
        }
      }
    });
    return deferred.promise;
  }
});
